<template>
  <div>
    <template v-if="src">
      <app-link
        class="logo__wrapper"
        :link="link"
        v-if="isLink"
      >
        <img
          class="logo__img"
          :src="src"
          :alt="alt"
          v-bind="$attrs"
        >
      </app-link>

      <img
        class="logo__img"
        :src="src"
        :alt="alt"
        v-bind="$attrs"
        v-else
      >
    </template>
  </div>
</template>

<script setup>
import { defineAsyncComponent, computed } from 'vue'
import Link from '@/classes/links/Link'
import { useClientStore } from '@/stores/ClientStore'
import { useI18n } from '@/vendors/i18n'

const AppLink = defineAsyncComponent(() => import('&/atoms/AppLink'))

defineOptions({ inheritAttrs: false })

const { logo, type, url } = defineProps({
  logo: { type: Object, default: () => ({}) },
  type: { type: String, default: 'link' },
  url: { type: Object, default: () => ({}) }
})

const { t, translate } = useI18n()
const { getClient } = useClientStore()
const { client } = getClient()

const alt = t('literal.logo_of_x', { x: client.value.name })
const link = new Link({
  url,
  target_url: '/'
})

const src = computed(() => translate(logo) || translate(client.value.logo))
const isLink = computed(() => type === 'link')
</script>

<style lang="scss" scoped>
.logo__img {
  display: block;
}

:deep(.logo__wrapper) {
  display: inline-block;
  position: relative;
}
</style>